export default __webpack_public_path__ + "static/media/2-color.25e7d1c8.svg";